export type FrequencyType = 'daily' | 'weekly'

export interface HabitLogData {
  startedAt: string | null
  durationMinutes: number | null
  note: string | null
}

export interface Habit {
  id: number
  name: string
  description: string | null
  frequencyType: FrequencyType
  frequencyDays: number[]
  color: string | null
  position: number
  loggingEnabled?: boolean
  loggingEnabledSetting?: boolean | null
  scheduledToday?: boolean
  completedToday?: boolean
  todayLog?: HabitLogData | null
  completedDates?: string[]
  extraCompletedDates?: string[]
  achievementRate?: number
  logDetails?: Record<string, HabitLogData>
}

export type LoggingEnabledSetting = true | false | null

export interface HabitFormData {
  name: string
  description: string
  frequencyType: FrequencyType
  frequencyDays: number[]
  color: string
  loggingEnabled: LoggingEnabledSetting
}

export interface HabitsIndexProps {
  habits: Habit[]
  today: string
  todaySatisfaction?: number | null
}

export interface HabitsWeeklyProps {
  habits: Habit[]
  startDate: string
  endDate: string
  today: string
  satisfactions: Record<string, number>
}

export interface HabitsMonthlyProps {
  habits: Habit[]
  month: string
  startDate: string
  endDate: string
  today: string
  satisfactions: Record<string, number>
}

export interface HabitsTimelineProps {
  habits: Habit[]
  startDate: string
  endDate: string
  today: string
  satisfactions: Record<string, number>
}

// 日曜始まり（getDay() の戻り値と一致）
export const WEEKDAY_LABELS = [
  '日',
  '月',
  '火',
  '水',
  '木',
  '金',
  '土',
] as const
export const WEEKDAY_LABELS_EN = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat',
] as const

// 月曜始まり（カレンダー表示用）
export const WEEKDAY_LABELS_MONDAY_START = [
  '月',
  '火',
  '水',
  '木',
  '金',
  '土',
  '日',
] as const
